(() => {
  document.querySelectorAll('[data-quantity-picker]').forEach((picker) => {
    const trigger = picker.querySelector('[data-quantity-trigger]');
    const select = picker.querySelector('[data-quantity-select]');
    const currentValue = picker.querySelector('[data-quantity-current]');
    const dialog = picker.querySelector('[data-quantity-dialog]');
    const closeButton = picker.querySelector('[data-quantity-close]');
    const options = [...picker.querySelectorAll('[data-quantity-option]')];
    if (!trigger || !select || !currentValue || !dialog || typeof dialog.showModal !== 'function') return;

    const updatePicker = () => {
      currentValue.textContent = select.value;
      options.forEach((option) => {
        option.setAttribute('aria-pressed', option.dataset.quantityOption === select.value ? 'true' : 'false');
      });
    };
    const openPicker = () => {
      if (dialog.open) return;
      dialog.showModal();
      trigger.setAttribute('aria-expanded', 'true');
      options.find((option) => option.dataset.quantityOption === select.value)?.focus();
    };

    trigger.hidden = false;
    select.setAttribute('aria-hidden', 'true');
    select.tabIndex = -1;
    trigger.addEventListener('click', openPicker);
    trigger.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        openPicker();
      }
    });
    closeButton?.addEventListener('click', () => dialog.close());
    options.forEach((option) => option.addEventListener('click', () => {
      const nextValue = option.dataset.quantityOption;
      if (nextValue && select.value !== nextValue) {
        select.value = nextValue;
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      dialog.close();
    }));
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('close', () => {
      trigger.setAttribute('aria-expanded', 'false');
      trigger.focus();
    });
    select.addEventListener('input', updatePicker);
    select.addEventListener('change', updatePicker);
    updatePicker();
  });

  const variantSelect = document.querySelector('[data-m27-variant-select]');
  const productForm = document.getElementById('M27ProductForm');
  const buyNowForm = document.getElementById('M27BuyNowForm');
  const buyNowVariant = buyNowForm?.querySelector('[data-m27-checkout-variant]');
  const buyNowQuantity = buyNowForm?.querySelector('[data-m27-checkout-quantity]');
  const productQuantity = productForm?.querySelector('[name="quantity"]');
  const syncBuyNowForm = () => {
    if (!buyNowForm || !buyNowVariant || !buyNowQuantity || !productForm) return;
    const selectedVariant = variantSelect?.value || productForm.querySelector('[name="id"]')?.value;
    if (selectedVariant) buyNowVariant.value = selectedVariant;
    if (productQuantity) buyNowQuantity.value = productQuantity.value;
  };
  if (buyNowForm) {
    syncBuyNowForm();
    variantSelect?.addEventListener('change', syncBuyNowForm);
    productQuantity?.addEventListener('input', syncBuyNowForm);
    productQuantity?.addEventListener('change', syncBuyNowForm);
    buyNowForm.addEventListener('submit', (event) => {
      syncBuyNowForm();
      if (productQuantity && !productQuantity.reportValidity()) event.preventDefault();
    });
  }

  document.addEventListener('submit', (event) => {
    const submitter = event.submitter;
    if (!submitter?.matches('[data-m27-checkout]')) return;

    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    let returnTo = form.querySelector('input[name="return_to"]');
    if (!returnTo) {
      returnTo = document.createElement('input');
      returnTo.type = 'hidden';
      returnTo.name = 'return_to';
      returnTo.dataset.m27CheckoutReturnTo = 'true';
      form.append(returnTo);
    }
    returnTo.value = '/checkout';
  }, true);

  const updateAvailability = (available, price) => {
    if (price) {
      document.querySelectorAll('[data-m27-price], [data-m27-sticky-price]').forEach((node) => { node.textContent = price; });
    }
    document.querySelectorAll('[data-m27-add], [data-m27-checkout], [data-m27-sticky-add]').forEach((button) => {
      button.disabled = !available;
      if (button.hasAttribute('data-m27-add') || button.hasAttribute('data-m27-sticky-add')) button.textContent = available ? 'Add to cart' : 'Unavailable';
    });
    const stock = document.querySelector('[data-m27-stock]');
    if (stock) {
      stock.classList.toggle('m27-stock--sold-out', !available);
      const label = stock.querySelector('[data-m27-stock-label]');
      if (label) label.textContent = available ? 'Available' : 'Currently unavailable';
    }
    const bundleMain = document.querySelector('[data-m27-fbt-main]');
    const selectedVariant = variantSelect?.selectedOptions[0];
    if (bundleMain && selectedVariant) {
      bundleMain.dataset.variantId = selectedVariant.value;
      bundleMain.dataset.priceCents = selectedVariant.dataset.priceCents || '0';
      bundleMain.dataset.available = selectedVariant.dataset.available || 'false';
      const mainCardPrice = bundleMain.closest('[data-m27-fbt-card]')?.querySelector('[data-m27-fbt-card-price]');
      if (mainCardPrice && price) mainCardPrice.textContent = price;
      bundleMain.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };

  if (variantSelect) {
    variantSelect.addEventListener('change', () => {
      const option = variantSelect.selectedOptions[0];
      updateAvailability(option.dataset.available === 'true', option.dataset.price || '');
    });
  }

  const bundle = document.querySelector('[data-m27-fbt]');
  if (bundle) {
    const mainItem = bundle.querySelector('[data-m27-fbt-main]');
    const mainQuantity = document.querySelector('[data-m27-fbt-quantity]');
    const options = [...bundle.querySelectorAll('[data-m27-fbt-option]')];
    const defaultOptions = options.filter((option) => !option.disabled && option.dataset.available === 'true').slice(0, 2);
    options.forEach((option) => { option.checked = defaultOptions.includes(option); });
    const submit = bundle.querySelector('[data-m27-fbt-submit]');
    const countLabel = bundle.querySelector('[data-m27-fbt-count]');
    const totalLabel = bundle.querySelector('[data-m27-fbt-total]');
    const message = bundle.querySelector('[data-m27-fbt-message]');
    const currency = bundle.dataset.currency || 'USD';
    const locale = bundle.dataset.locale || 'en-US';
    let isSubmitting = false;

    const formatPrice = (cents) => {
      try {
        return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(cents / 100);
      } catch {
        return `$${(cents / 100).toFixed(2)}`;
      }
    };

    const selectedItems = () => [mainItem, ...options].filter((item) => item?.checked);
    const getMainQuantity = () => {
      const value = Number.parseInt(mainQuantity?.value || '1', 10);
      return Number.isFinite(value) ? Math.max(1, Math.min(12, value)) : 1;
    };
    const updateBundle = () => {
      const selected = selectedItems();
      const quantity = getMainQuantity();
      const totalUnits = selected.reduce((sum, item) => sum + (item === mainItem ? quantity : 1), 0);
      const total = selected.reduce((sum, item) => sum + (Number(item.dataset.priceCents) || 0) * (item === mainItem ? quantity : 1), 0);
      const qualifiesForDiscount = totalUnits >= 3;
      const discountedTotal = qualifiesForDiscount ? Math.round(total * .9) : total;
      const unavailable = selected.filter((item) => item.dataset.available !== 'true' || !item.dataset.variantId);
      const itemNames = selected.filter((item) => item !== mainItem).map((item) => item.closest('[data-m27-fbt-card]')?.querySelector('h3')?.textContent.trim());

      bundle.querySelectorAll('[data-m27-fbt-card]').forEach((card) => {
        const input = card.querySelector('input[type="checkbox"]');
        card.classList.toggle('is-selected', Boolean(input?.checked));
      });
      if (countLabel) countLabel.textContent = isSubmitting ? 'Adding…' : `Buy all ${totalUnits} ${totalUnits === 1 ? 'item' : 'items'}`;
      if (totalLabel) totalLabel.textContent = formatPrice(discountedTotal);
      if (message) {
        if (unavailable.length) {
          message.textContent = `${itemNames.join(', ')} ${itemNames.length === 1 ? 'is not available and cannot be added yet. Deselect it' : 'are not available and cannot be added yet. Deselect them'} to add the available items.`;
        } else if (qualifiesForDiscount) {
          message.textContent = `You save ${formatPrice(total - discountedTotal)} (10%). Discount applied automatically in your cart and at checkout.`;
        } else {
          message.textContent = `Add ${3 - totalUnits} more ${3 - totalUnits === 1 ? 'item' : 'items'} to save 10%.`;
        }
      }
      if (submit) submit.disabled = isSubmitting || selected.length === 0 || unavailable.length > 0;
    };

    options.forEach((option) => option.addEventListener('change', updateBundle));
    mainItem?.addEventListener('change', updateBundle);
    mainQuantity?.addEventListener('input', updateBundle);
    mainQuantity?.addEventListener('change', updateBundle);
    const modelVariantSelect = document.querySelector('[data-model-variant]');
    modelVariantSelect?.addEventListener('change', () => {
      const option = modelVariantSelect.selectedOptions[0];
      if (!mainItem || !option) return;
      mainItem.dataset.variantId = option.value;
      mainItem.dataset.priceCents = option.dataset.priceCents || '0';
      mainItem.dataset.available = option.dataset.available || 'false';
      const mainCardPrice = mainItem.closest('[data-m27-fbt-card]')?.querySelector('[data-m27-fbt-card-price]');
      if (mainCardPrice) mainCardPrice.textContent = option.dataset.price || '';
      updateBundle();
    });
    updateBundle();

    submit?.addEventListener('click', async () => {
      const selected = selectedItems();
      if (submit.disabled || isSubmitting) return;
      const personalizationForm = document.querySelector('form[data-hz-name-form]');
      if (personalizationForm && selected.includes(mainItem) && !personalizationForm.reportValidity()) return;
      isSubmitting = true;
      submit.setAttribute('aria-busy', 'true');
      updateBundle();

      try {
        const quantity = getMainQuantity();
        const items = selected.map((item) => {
          const line = { id: Number(item.dataset.variantId), quantity: item === mainItem ? quantity : 1 };
          if (item === mainItem && personalizationForm) {
            line.properties = {};
            for (const [key, value] of new FormData(personalizationForm)) {
              const match = /^properties\[(.+)\]$/.exec(key);
              if (match && typeof value === 'string') line.properties[match[1]] = value;
            }
          }
          return line;
        });
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'The selected items could not be added.');
        window.location.assign(`${root}cart`);
      } catch (error) {
        isSubmitting = false;
        submit.removeAttribute('aria-busy');
        updateBundle();
        if (message) message.textContent = error.message || 'The selected items could not be added. Please try again.';
      }
    });
  }

  if (document.body.dataset.pageHandle === 'about-us-2') {
    const pageMain = document.querySelector('#MainContent');
    const pageHeading = pageMain?.querySelector('[data-pf-type="Heading2"]') || pageMain?.querySelector('h3');
    if (pageHeading && pageHeading.tagName !== 'H1') {
      const mainHeading = document.createElement('h1');
      [...pageHeading.attributes].forEach((attribute) => mainHeading.setAttribute(attribute.name, attribute.value));
      mainHeading.innerHTML = pageHeading.innerHTML;
      pageHeading.replaceWith(mainHeading);
    }

    const aboutEmail = pageMain?.querySelector('#contact_form input[name="contact[email]"]');
    if (aboutEmail && aboutEmail.labels.length === 0 && !aboutEmail.hasAttribute('aria-label')) {
      if (!aboutEmail.id) aboutEmail.id = 'HearzenAboutContactEmail';
      if (!aboutEmail.autocomplete) aboutEmail.autocomplete = 'email';
      const emailLabel = document.createElement('label');
      emailLabel.className = 'visually-hidden';
      emailLabel.htmlFor = aboutEmail.id;
      emailLabel.textContent = 'Email address';
      aboutEmail.before(emailLabel);
    }
  }

  if (document.body.dataset.template === 'policy') {
    const policyTitle = document.querySelector('.shopify-policy__title h1');
    const policyBodyTitle = document.querySelector('.shopify-policy__body .rte > h1:first-child');
    const normalizeTitle = (title) => title?.textContent?.trim().replace(/\s+/g, ' ').toLocaleLowerCase();
    if (normalizeTitle(policyTitle) && normalizeTitle(policyTitle) === normalizeTitle(policyBodyTitle)) {
      policyBodyTitle.remove();
    }
  }

})();
